import React from 'react';
import { Helmet } from 'react-helmet';

const Contact = () => {
  return (
    <div className="contact page-container">
      <Helmet>
        <title>Kontak Kami | Pintar Pilih Kuliah</title>
        <meta name="description" content="Hubungi tim Pintar Pilih Kuliah untuk konsultasi dan informasi lebih lanjut mengenai layanan kami." />
      </Helmet>
      
      <div className="container">
        <h1>Kontak Kami</h1>
        <p>Halaman Kontak akan segera hadir.</p>
      </div>
    </div>
  );
};

export default Contact;
